var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('login-dialog',{attrs:{"referal":_vm.config.referralSources,"sitekey":_vm.config.recaptchaKey,"next":_vm.next,"skip-captcha":_vm.skipCaptcha}}),_c('signup-dialog',{attrs:{"referal":_vm.config.referralSources,"google-id":_vm.config.googleAppId,"sitekey":_vm.config.recaptchaKey,"next":_vm.next,"skip-captcha":_vm.skipCaptcha}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }